/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Zap = [
  "svg",
  defaultAttributes,
  [["polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" }]]
];

export { Zap as default };
//# sourceMappingURL=zap.js.map
